module.exports = __webpack_public_path__ + "static/man_payment-162e54448b42730d573b674c9c1812af.svg";